import React, { Component } from 'react';
import './index.scss';
import CrgtEvent from '../CrgtEvent';
import _ from 'lodash';

export default class Image extends Component {

  getClass = (size) => {
    let imgClass = 'default-img';
    switch (size) {
      case 'large':
        imgClass = 'large-img';
        break;
      case 'small':
        imgClass = 'small-img';
        break;
      case 'default-hz':
        imgClass = 'default-hz-img';
        break;
      case 'default-vt':
        imgClass = 'default-vt-img';
        break;
      default:
        break;
    }
    return imgClass;
  }
  render() {
    const { src, alt = '', size = 'default', href, target, cid, vid, nativePage, event = 'doNothing', style={}, ...restProps } = this.props;
    let params = {};
    if (event === 'openUrl') {
      params = (!_.isNil(href) && !_.isNil(target))? { url: href, target } : {}
    }
    if (event === 'openView') {
      params = (!_.isNil(cid) && !_.isNil(vid)) ? { cid, vid } : {}
    }
    if (event === 'openNativeView') {
      params =  { nativePage }
    }
    const clickEvent = event !== undefined && function () { CrgtEvent[`${event}`](params) };
    let imgClass = this.getClass(size);
    style.background = `url(${src}) 0 0 / 100% no-repeat`;
    //return createElement(config);
    return (
      <div {...restProps} className={imgClass} style={style} onClick={clickEvent}>
        <img src={src} alt={alt} />
      </div>
    )
  }
}